import { Tooltip } from "@blueprintjs/core";
import React, { useMemo } from "react";
import AccuracyIcon from "./components/AccuracyIcon";
import { getAccuracyValue } from "store/rs-workspace/utils/calculations.utils";
import * as styles from "./styles.module.scss";
const AccuracyIndicator = ({ calculatedAccuracy, selectedAccuracy = null, forcedAccuracy, defaultIsOpen = false, tooltipDisabled = false, }) => {
    const calculatedAccuracyValue = useMemo(() => {
        const { uncertainty, variability } = calculatedAccuracy ?? {};
        return getAccuracyValue(uncertainty, variability);
    }, [calculatedAccuracy]);
    const accuracyValue = useMemo(() => {
        const { uncertainty, variability } = selectedAccuracy ?? {};
        const { level: selectedAccuracyLevel, label: selectedAccuracyValue } = forcedAccuracy?.accuracy || getAccuracyValue(uncertainty, variability);
        if (calculatedAccuracy === null) {
            return selectedAccuracyValue;
        }
        return calculatedAccuracyValue.level > selectedAccuracyLevel
            ? calculatedAccuracyValue.label
            : selectedAccuracyValue;
    }, [
        calculatedAccuracy,
        calculatedAccuracyValue.label,
        calculatedAccuracyValue.level,
        forcedAccuracy,
        selectedAccuracy,
    ]);
    const tooltipMessage = useMemo(() => {
        const baseMessage = `The results will be calculated with ${accuracyValue} accuracy based on:`;
        if (forcedAccuracy) {
            return `You have already selected higher calculation accuracy for this data source in ${forcedAccuracy.resultElementName}.
        ${baseMessage}`;
        }
        return calculatedAccuracy === null
            ? baseMessage
            : `The results have already been calculated with ${calculatedAccuracyValue.label} accuracy based on:`;
    }, [accuracyValue, calculatedAccuracy, calculatedAccuracyValue.label, forcedAccuracy]);
    return (React.createElement(Tooltip, { minimal: true, openOnTargetFocus: false, disabled: tooltipDisabled, placement: "top", content: React.createElement("div", { className: styles.tooltipContent },
            React.createElement("p", { "data-testid": "tooltip-message", className: styles.title }, tooltipMessage),
            selectedAccuracy !== null ? (React.createElement("ul", { className: styles.list },
                React.createElement("li", null,
                    "Uncertainty - ",
                    selectedAccuracy.uncertainty),
                React.createElement("li", null,
                    "Variability - ",
                    selectedAccuracy.variability))) : (`Uncertainty - ${calculatedAccuracy?.uncertainty}; Variability - ${calculatedAccuracy?.variability}`)), popoverClassName: styles.tooltip, targetTagName: "div", usePortal: false, defaultIsOpen: defaultIsOpen },
        React.createElement("div", { className: styles.main },
            React.createElement(AccuracyIcon, { accuracy: accuracyValue, className: styles.accuracyIcon }))));
};
export default AccuracyIndicator;
